import type { ExplicitAny } from "~/@types/generics"

export function insertItemsByIndex<TArray, TItem extends { index: number; value: ExplicitAny }>(
  array: TArray[],
  items: TItem[]
) {
  const newArray = [...array]

  for (const item of items.sort((a, b) => a.index - b.index)) {
    newArray.splice(item.index, 0, item.value)
  }

  return newArray as TItem extends { index: number; value: infer TValue } ? (TArray | TValue)[] : never
}
